import { useCallback } from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Crown, Users, ArrowRight } from "lucide-react";

const Exclusivity = () => {
  const scrollToCalendly = useCallback(() => {
    const calendlySection = document.getElementById("calendly");
    if (calendlySection) {
      calendlySection.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <section className="py-24 md:py-32 relative overflow-hidden" style={{ background: "linear-gradient(180deg, #0a1628 0%, #0d1a3d 50%, #0f2057 100%)" }}>
      {/* Decorative elements */}
      <div className="absolute inset-0 opacity-40">
        <div className="absolute top-0 left-1/4 w-96 h-96 rounded-full blur-3xl" style={{ backgroundColor: "rgba(59, 130, 246, 0.12)" }} />
        <div className="absolute bottom-0 right-1/4 w-80 h-80 rounded-full blur-3xl" style={{ backgroundColor: "rgba(37, 99, 235, 0.15)" }} />
      </div>

      <div className="container px-4 relative z-10">
        {/* Section header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="text-xs tracking-[0.3em] uppercase text-[#60a5fa] font-semibold mb-4">
            Exclusividad y Dedicación
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium text-white tracking-tight">
            Socios Estratégicos
          </h2>
        </motion.div>

        {/* Main content */}
        <div className="max-w-4xl mx-auto">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-lg md:text-xl text-white/80 text-center mb-12 leading-relaxed"
          >
            Nuestros clientes comparten un rasgo: son líderes comprometidos con su éxito.
          </motion.p>

          {/* Feature cards */}
          <div className="grid md:grid-cols-2 gap-6 mb-16">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="relative p-8 rounded-2xl border border-white/10 backdrop-blur-sm"
              style={{ background: "linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(59, 130, 246, 0.08) 100%)" }}
            >
              <div className="flex items-start gap-4">
                <div className="p-3 rounded-xl bg-[#3b82f6]/15">
                  <Users className="w-6 h-6 text-[#60a5fa]" />
                </div>
                <div>
                  <h3 className="text-xl font-medium text-white mb-3">
                    No somos una agencia
                  </h3>
                  <p className="text-white/70 leading-relaxed">
                    Combinamos la precisión de la ingeniería de negocios con la sofisticación de la reputación institucional para construir tu legado.
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="relative p-8 rounded-2xl border border-white/10 backdrop-blur-sm"
              style={{ background: "linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(59, 130, 246, 0.08) 100%)" }}
            >
              <div className="flex items-start gap-4">
                <div className="p-3 rounded-xl bg-[#3b82f6]/15">
                  <Crown className="w-6 h-6 text-[#60a5fa]" />
                </div>
                <div>
                  <h3 className="text-xl font-medium text-white mb-3">
                    Honramos la excelencia
                  </h3>
                  <p className="text-white/70 leading-relaxed">
                    Mantenemos cupos reducidos asegurando el rigor y el cuidado personalizado que una trayectoria como la tuya merece.
                  </p>
                </div>
              </div>
            </motion.div>
          </div>

          {/* CTA */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="text-center"
          >
            <Button
              variant="gold"
              size="xl"
              onClick={scrollToCalendly}
              className="tracking-wider font-semibold rounded-full group"
            >
              AGENDAR LLAMADA
              <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
            </Button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Exclusivity;
